<template>
  <div class="row">
    <div class="form-group">
      <label for="day-of-week">Day of Week</label>
      <select id="day-of-week" v-model="formVisit.day" class="form-control">
        <option v-for="(day, index) in days" :key="day" :value="index">{{ day }}</option>
      </select>
    </div>
    <div class="form-group">
      <label for="day-of-week">Time</label>
      <div>
        <div class="d-inline-block">
          <select v-model="formVisit.time_hour" name="" class="form-control" id="">
            <option v-for="n in 12" :key="n" :value="n.toString().padStart(2, '0')">{{n.toString().padStart(2, '0')}}</option>
          </select>
        </div>
            
        <div class="d-inline-block p-1">:</div>
        <div class="d-inline-block p-1">
          <select name="" v-model="formVisit.time_minute" class="form-control" id="">
            <option value="00">00</option>
            <option v-for="n in 60" :key="n" :value="n.toString().padStart(2, '0')">{{n.toString().padStart(2, '0')}}</option>
          </select>
        </div> 

        <div class="d-inline-block p-1">
          <select v-model="formVisit.time_period" name="" class="form-control" id="">
            <option  value="am" >am</option>
            <option value="pm" >pm</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import JetDialogModal from '@/Jetstream/DialogModal'
  import JetDangerButton from '@/Jetstream/DangerButton'
  import moment from 'moment'

  export default {
    data() {
      let days = []
      let date = null
      for (var i=0; i<7; i++) {
        date = moment().day(i)
        days[i] = date.format('dddd')
      }
      let visitTime = null
      if (this.location && this.location.location_visit_on_time) {
        visitTime = moment(this.location.location_visit_on_time, "HH:mm:ss")
      }
      return {
        days: days,
        formVisit: this.$inertia.form({
          _method: 'put',
          day: this.location ? this.location.location_visit_on_day : null,
          time_hour: this.location && visitTime ? visitTime.format('hh') : null,
          time_minute: this.location && visitTime ? visitTime.format('mm') : null,
          time_period: this.location && visitTime ? visitTime.format('a') : null,
          time: null
        })
      }
    },
    props: {
      location: Object
    },
    components: {
      JetDialogModal,
      JetDangerButton,
    },
    created() {
      this.moment = moment
    },
    methods: {
      saveVisit() {
        if (this.formVisit.time_hour) {
          let time = moment(this.formVisit.time_hour + ":" + this.formVisit.time_minute + this.formVisit.time_period, 'hh:mm A')
          this.formVisit.time = time.format('HH:mm:00')
        }
        this.formVisit.post(this.route('mtd.locationvisit', this.location.id))
      },
    }
  }
</script>
